import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  row: "",
  wrap: "",
  class: "radio-component p-2"
}
const _hoisted_2 = ["readonly"]
const _hoisted_3 = ["innerHTML"]

import { ref, watch, onMounted } from 'vue'
import { forEach } from "lodash"
import { answerItemBodyParser } from "../../../../helpers/question-parser"
import AnswerItem from "../../../../common/AnswerItem"


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionSelect',
  props: {
    list: { default: () => [] },
    value: { default: () => [] },
    trueBgr: { default: '' },
    falseBgr: { default: '' },
    readonly: { type: Boolean, default: false },
    callBackChange: { type: Function, default: () => {} },
    color: { default: '' }
  },
  setup(__props: any) {

const props = __props

const selected = ref('')
const items = ref<string[]>([])

watch(() => props.value, (val, oldVal) => {
  if (val !== oldVal) {
    selected.value = val.length ? val[0] : ''
  }
})

watch(() => props.list, (val, oldVal) => {
  if (val !== oldVal) {
    forEach(val, (item) => {
      items.value.push(answerItemBodyParser(item.body))
    })
  }
}, { immediate: true })

onMounted(() => {
  if (props.value.length) {
    selected.value = props.value.length ? props.value[0] : ''
  }
})

const getStyle = (item: AnswerItem) => {
  if (props.trueBgr && item.correct) {
    return {
      'background-color': props.trueBgr
    }
  }
  if (props.falseBgr && !item.correct) {
    return {
      'background-color': props.falseBgr
    }
  }
}

const onChange = (val: any) => {
  var value = val != '' ? [val] : []
  props.callBackChange(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
      readonly: __props.readonly,
      onChange: onChange,
      style: _normalizeStyle(__props.color != '' ? { 'background-color': __props.color } : {})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("option", {
          key: index,
          innerHTML: item
        }, null, 8 /* PROPS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ], 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_2), [
      [_vModelSelect, selected.value]
    ])
  ]))
}
}

})